import './site.js';
import { botFlowCanvas } from './bot-flow-canvas.js';
import { botFlowEditor, botApiVariablePicker } from './bot-flow-editor.js';

const registerDevelopmentComponents = () => {
    window.Alpine.data('botFlowCanvas', botFlowCanvas);
    window.Alpine.data('botFlowEditor', botFlowEditor);
    window.Alpine.data('botApiVariablePicker', botApiVariablePicker);
};
if (window.Alpine) {
    registerDevelopmentComponents();
} else {
    document.addEventListener('alpine:init', registerDevelopmentComponents, { once: true });
}
